/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconChevronCompactUp = createReactComponent(
  "chevron-compact-up",
  "IconChevronCompactUp",
  [["path", { d: "M4 13l8 -3l8 3", key: "svg-0" }]]
);

export { IconChevronCompactUp as default };
//# sourceMappingURL=IconChevronCompactUp.js.map
